export default "__VITE_ASSET__f252d3bd__"